<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  import Vue from 'vue';
  import 'normalize.css';
  import 'flex-layout-attribute';
  import '@/css/main.scss';

  import Headbar from "./components/Headbar";




  export default {
    components: {Headbar},
    name: 'App'
  }




</script>

<style>
  #app {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue